var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loggingIn)?_c('div',[_c('loader')],1):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }